import Accordions from './modules/accordion';
import Tabs from './modules/tabs';
// import Includes from './modules/include';
// import AnchorLink from './modules/anchorlink';
// import HashUrl from './modules/hash_url';
import AgreeCheck from './modules/check';
import './modules/comingsoon';
import './modules/newitems';
import './modules/rt_support';
import './modules/scrollbar';
import './modules/carousel';
import '../scss/new_pc.scss';
import '../scss/new_sp.scss';

document.addEventListener('DOMContentLoaded',function(){

  //html include
  // const includeContainers = Array.from(document.querySelectorAll('[data-inc]'));
  // includeContainers.forEach((container) => {
  //   new Includes(container);
  // });

  //Accordion
  const accBtns = Array.from(document.querySelectorAll('.js-acc-btn'));
  accBtns.forEach((accordionBtn) => {
    new Accordions(accordionBtn);
  });

  // 同意チェック
  const checkboxs = Array.from(document.querySelectorAll('.js-agreecheck-input'));
  checkboxs.forEach((check) => {
    new AgreeCheck(check);
  });

  // 画像遅延ロード
  function imageLoad(){
    if ("loading" in HTMLImageElement.prototype) {
      console.log('A');
      var images = document.querySelectorAll('img.lazyload');
      var sources = document.querySelectorAll("source[data-srcset]");
      sources.forEach(function (source) {
          source.srcset = source.dataset.srcset;
      });
      images.forEach(function (img) {
          img.src = img.dataset.src;
      });
    } else {
      console.log('B');
      var script = document.createElement("script");
      script.src = "/sw/onlineshop/js/lazysizes.min.js";
      document.body.appendChild(script);
    }
  }
  window.addEventListener('focus', function(){
    imageLoad();
  });

  window.addEventListener('load',function(){

    //タブ切り替え
    const tabsBtn = Array.from(document.querySelectorAll('.js-tabs-btn'));
    tabsBtn.forEach((tabBtn) => {
      new Tabs(tabBtn);
    });

    // 画像遅延ロード
    imageLoad();

    // //smooth anchor
    // //ページ内リンク
    // let anchorLinks = Array.from(document.querySelectorAll('a'));
    // anchorLinks.forEach((link) => {
    //   new AnchorLink(link);
    // });
    // //ハッシュ付きURLでアクセス
    // new HashUrl();

  });

});




